import { useCallback, useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { useLicense } from "../license";
import { logger } from "../log";
import { trackingContext } from "./context";
import type { TrackingContext } from "./types";

const log = logger("track");

export function useTracking() {
  useTrackingIdentity();
  usePageTracking();
}

export function useTrackingContext(): TrackingContext {
  return useContext(trackingContext);
}

export function useTrackEvent(): typeof trackEvent {
  const defaults = useTrackingContext();
  return useCallback(
    (action, details) => {
      trackEvent(action, { ...defaults, ...details });
    },
    [defaults],
  );
}

function useTrackingIdentity() {
  const license = useLicense();

  useEffect(() => {
    if (license) {
      window.gtag("set", "user_id", license.id);
      window.gtag("set", "user_properties", {
        demo: license.demo,
        freeversion: license.freeversion,
      });
    }
  }, [license]);
}

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    window.gtag("event", "page_view");
  }, [location]);
}

export function trackEvent(
  action: string,
  details: { category?: string; label?: string; value?: number } = {},
) {
  log.silly(action, details);
  window.gtag("event", action, details);
}
